import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0c1b03de"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box_ops_seach"
};
const _hoisted_2 = {
  key: 0,
  class: "tag_boxs"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "text_ops1"
};
const _hoisted_6 = {
  class: "tag_2"
};
const _hoisted_7 = {
  key: 0,
  class: "loading"
};
const _hoisted_8 = {
  key: 1,
  class: "no-more"
};
const _hoisted_9 = {
  key: 2,
  class: "tree_box"
};
const _hoisted_10 = {
  class: "custom-tree-node"
};
const _hoisted_11 = {
  style: {
    "font-size": "15px"
  }
};
const _hoisted_12 = {
  key: 3,
  class: "tree_box"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "text_ops1"
};
const _hoisted_15 = {
  class: "tag_2"
};
import { debounce } from "lodash";
import { ref } from "vue";
import { Search, Expand, Fold } from "@element-plus/icons-vue";
import { getOrganizationApi, getsearch_user, getarchive_list } from "@/service/modules/alllist";
import { useScrollLoad } from "@/hooks/useScrollLoad";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["set_from"],
  setup(__props, {
    emit: __emit
  }) {
    const scrollContainer = ref(null);
    // 使用滚动加载 Hook
    const {
      list,
      loading,
      hasMore,
      reset,
      loadData
    } = useScrollLoad({
      pageSize: 40,
      requestData: getarchive_list,
      searchParams: () => ({})
    });
    const handScroll = () => {
      if (!scrollContainer.value) return;
      // 获取滚动容器
      const container = scrollContainer.value;
      // 计算滚动位置
      const scrollTop = container.scrollTop; // 当前滚动距离
      const scrollHeight = container.scrollHeight; // 总高度
      const clientHeight = container.clientHeight; // 可视区高度
      if (scrollHeight - scrollTop - clientHeight <= 50) {
        loadData();
      }
    };
    const tag_list = ref([{
      name: "存档人员",
      id: 1
    }, {
      name: "组织架构",
      id: 2
    }]);
    const active_id = ref(1);
    const set_active = id => {
      active_id.value = id;
      if (id == 1) {
        loadData();
      }
    };
    const searchQuery = ref("");
    // const loading = ref(false);
    const defaultProps = {
      children: "children",
      label: "name",
      isLeaf: "leaf"
    };
    const user_list = ref([]);
    const changes = debounce(async () => {
      user_list.value = [];
      loading.value = true; // 开始加载
      try {
        const res = await getsearch_user({
          search: searchQuery.value
        });
        if (res.code == 0) {
          user_list.value = res.data.data; // 更新聊天列表
        }
      } catch (error) {
        console.error("请求错误:", error); // 错误处理
      } finally {
        loading.value = false; // 结束加载
      }
    }, 300);
    // const Getarchive_list = async () => {
    //   user_list.value = [];
    //   loading.value = true; // 开始加载
    //   try {
    //     const res: any = await getarchive_list({});
    //     if (res.code == 0) {
    //       user_list.value = res.data.data; // 更新聊天列表
    //     }
    //   } catch (error) {
    //     console.error("请求错误:", error); // 错误处理
    //   } finally {
    //     loading.value = false; // 结束加载
    //   }
    // };
    // Getarchive_list();
    const loadNodeData = async (node, resolve, reject) => {
      loading.value = true; // 开始加载
      // 检查节点是否已经加载过，避免重复请求
      if (node.children && node.children.length > 0) {
        resolve(node.children); // 如果节点已有子节点，直接返回
        loading.value = false; // 结束加载
        return;
      }
      let id = node?.data?.id || 0;
      try {
        await get_list(id); // 使用节点的 id 获取数据
        resolve(data_list.value); // 确保在数据加载完成后返回数据
      } catch (error) {
        reject(); // 如果发生错误，调用 reject
      } finally {
        loading.value = false; // 结束加载
      }
    };

    const userids = ref("");
    const set_user = item => {
      userids.value = item.userid;
      emit("set_from", item.userid);
    };
    const boxWidth = ref(254);
    const isTreeVisible = ref(true);
    const initialExpandedKeys = ref([1, 11]);
    const data_list = ref([]);
    const get_list = async id => {
      try {
        const res = await getOrganizationApi(id);
        if (res.code == 0) {
          // data_list.value = res.data.list;
          const updatedList = res.data.list.map(item => ({
            ...item,
            leaf: item?.children?.length ? false : true
          }));
          const updatedArray = res.data.user_list.map(item => ({
            ...item,
            leaf: item?.children?.length ? false : true
          }));
          data_list.value = [...res.data.list, ...updatedArray];
          // 检查 user_list 是否为数组且不为空
          // if (Array.isArray(res.data.user_list) && res.data.user_list.length > 0) {
          //   data_list.value.push(...res.data.user_list); // 将 user_list 数据推入 data_list
          // }
        }
      } catch (err) {} finally {}
    };
    const toggleTreeVisible = show => {
      boxWidth.value = show ? 254 : 30;
      isTreeVisible.value = show;
    };
    const onRightClick = node => {};
    const emit = __emit;
    const onNodeClick = data => {
      if (data?.userid) {
        emit("set_from", data.userid);
      }
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tree = _resolveComponent("el-tree");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["box_ops", isTreeVisible.value ? 'padd-16' : 'padd-8']),
        style: _normalizeStyle({
          width: boxWidth.value + 'px'
        })
      }, [_createElementVNode("div", _hoisted_1, [isTreeVisible.value ? (_openBlock(), _createBlock(_component_el_input, {
        key: 0,
        modelValue: searchQuery.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchQuery.value = $event),
        class: "seach",
        placeholder: "搜索",
        "prefix-icon": _unref(Search),
        clearable: "",
        onInput: _unref(changes)
      }, null, 8, ["modelValue", "prefix-icon", "onInput"])) : _createCommentVNode("", true), isTreeVisible.value ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 1,
        onClick: _cache[1] || (_cache[1] = $event => toggleTreeVisible(false))
      }, {
        default: _withCtx(() => [_createVNode(_unref(Fold))]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_icon, {
        key: 2,
        onClick: _cache[2] || (_cache[2] = $event => toggleTreeVisible(true))
      }, {
        default: _withCtx(() => [_createVNode(_unref(Expand))]),
        _: 1
      }))]), isTreeVisible.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tag_list.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["item_tags", active_id.value == item.id ? 'active1' : 'no_active1']),
          key: index,
          onClick: $event => set_active(item.id)
        }, _toDisplayString(item.name), 11, _hoisted_3);
      }), 128))])) : _createCommentVNode("", true), isTreeVisible.value && !searchQuery.value && active_id.value == 1 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "tree_box_user",
        ref_key: "scrollContainer",
        ref: scrollContainer,
        onScroll: handScroll
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["box_user", item.userid == userids.value ? 'active_boxuser' : '']),
          onClick: $event => set_user(item),
          key: index
        }, [_createElementVNode("div", _hoisted_5, [_createTextVNode(_toDisplayString(item.name), 1), _createElementVNode("span", _hoisted_6, "@" + _toDisplayString(item.dept_name), 1)])], 10, _hoisted_4);
      }), 128)), _unref(loading) ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [_createTextVNode("加载中...")])), [[_directive_loading, _unref(loading)]]) : _createCommentVNode("", true), !_unref(hasMore) && _unref(list).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 没有更多数据了 ")) : _createCommentVNode("", true)], 544)) : _createCommentVNode("", true), isTreeVisible.value && !searchQuery.value && active_id.value == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_withDirectives((_openBlock(), _createBlock(_component_el_tree, {
        "node-key": "id",
        props: defaultProps,
        onNodeClick: onNodeClick,
        onNodeContextmenu: onRightClick,
        load: loadNodeData,
        lazy: ""
      }, {
        default: _withCtx(({
          node
        }) => [_createElementVNode("span", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(node.label), 1)])]),
        _: 1
      })), [[_directive_loading, _unref(loading)]])])) : _createCommentVNode("", true), isTreeVisible.value && searchQuery.value && user_list.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user_list.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["box_user", item.userid == userids.value ? 'active_boxuser' : '']),
          onClick: $event => set_user(item),
          key: index
        }, [_createElementVNode("div", _hoisted_14, [_createTextVNode(_toDisplayString(item.name) + " ", 1), _createElementVNode("span", _hoisted_15, "@" + _toDisplayString(item.dept_name), 1)])], 10, _hoisted_13);
      }), 128))])) : _createCommentVNode("", true)], 6);
    };
  }
});